import { api } from "@/api"
import type { Ref } from "vue"
import { useQuery } from "@tanstack/vue-query"

type ListProductModifierGroupResponseItem = {
  id: string
  label: string
  isShared: boolean
  minOptions: number
  maxOptions: number
  options: Array<{
    id: string
    label: string
    priceOffset: number
    isSelected: boolean
  }>
}

const listProductModifierGroups = async (): Promise<
  ListProductModifierGroupResponseItem[]
> => {
  const response = await api.get<
    ListProductModifierGroupResponseItem[]
  >("/products/product-modifiers/")

  return response.body
}

export const useProductModifierGroups = () => {
  const queryReturn = useQuery({
    queryKey: [BASE_PRODUCT_MODIFIERS_QUERY_KEY],
    queryFn: () => listProductModifierGroups(),
    staleTime: 60 * 60 * 1000,
  })
  const getById = (
    id: string | undefined | Ref<string | undefined>
  ) =>
    computed(() =>
      unref(id)
        ? queryReturn.data.value?.find(
            (productModifierGroup) =>
              productModifierGroup.id === unref(id)
          )
        : undefined
    )

  return {
    ...queryReturn,
    getById,
  }
}
